import Container from './Container'

export default Container



// WEBPACK FOOTER //
// ./src/components/layout/Grid/Container/index.js